function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#64B5F6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 14.9c-.723 0-1.417.274-1.928.761a2.54 2.54 0 00-.8 1.839c0 .69.288 1.35.8 1.838A2.797 2.797 0 0018 20.1c.723 0 1.417-.274 1.928-.762a2.54 2.54 0 00.8-1.838c0-.69-.288-1.35-.8-1.838A2.797 2.797 0 0018 14.9zm0 6.933a4.66 4.66 0 01-3.214-1.269 4.233 4.233 0 01-1.332-3.064c0-1.15.48-2.252 1.332-3.064A4.66 4.66 0 0118 13.166a4.66 4.66 0 013.214 1.27 4.233 4.233 0 011.332 3.064c0 1.15-.48 2.252-1.332 3.064A4.66 4.66 0 0118 21.834zM18 11c-4.546 0-8.427 2.695-10 6.5 1.573 3.805 5.454 6.5 10 6.5s8.427-2.695 10-6.5c-1.573-3.805-5.454-6.5-10-6.5z",
  fill: "#E3F2FD"
});

function SvgInspection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgInspection;